module.exports = __webpack_public_path__ + "img/logoINETCMP.55d58180.png";